import { Link } from 'react-router';
import { Typography } from '@mui/material';
import { Row } from '../util/Page';
import AlertState from '../monitoring/AlertState';

const AlertDashboardRow = ({ alert }) => (
  <Row>
    <AlertState showLabel={false} state={alert.state} />
    <Typography variant="subtitle">
      Alert&nbsp;
      <Link to={`/data-alerts?aid=${alert.id}`}>&apos;{alert.name || 'Unnamed'}&apos;</Link>
      &nbsp;in {alert.buildings.length > 0 ? alert.buildings.length : 'all'} buildings
    </Typography>
  </Row>
);

export default AlertDashboardRow;
